export default __webpack_public_path__ + "static/media/bg-podcast-projeto-r1-sp.7a361038.jpg";